<template>
  <div class="login-retry-box">
    <div class="title center">
      {{ $t('login.retry.title') }}
    </div>

    <div>
      <div>{{ $t('login.retry.text1') }}</div>
      <div>{{ $t('login.retry.text2') }}</div>
    </div>

    <div class="caution-box">
      <div class="caution">{{ $t('login.retry.caution1') }}</div>
      <div>
        <div class="wrong-guide">{{ $t('login.retry.wrongGuide') }}</div>
        <img src="@/assets/images/page/photo_ex_wrong_02.png" alt="" />
        <img src="@/assets/images/page/photo_ex_wrong_03.png" alt="" />
      </div>
      <div>
        <div>{{ $t('login.retry.text3') }}</div>
        <div>{{ $t('login.retry.text4') }}</div>
      </div>
    </div>

    <div class="caution-box">
      <div class="caution">{{ $t('login.retry.caution2') }}</div>
      <div>
        <div class="wrong-guide">{{ $t('login.retry.wrongGuide') }}</div>
        <img src="@/assets/images/page/photo_ex_wrong_06.png" alt="" />
        <img src="@/assets/images/page/photo_ex_wrong_04.png" alt="" />
        <img src="@/assets/images/page/photo_ex_wrong_07.png" alt="" />
        <img src="@/assets/images/page/photo_ex_wrong_08.png" alt="" />
      </div>
      <div>
        <div>{{ $t('login.retry.text5') }}</div>
        <div>{{ $t('login.retry.text6') }}</div>
      </div>
    </div>

    <div class="btn-box center gap-10">
      <button
        type="button"
        class="btn btn-lg btn-dark"
        @click="
          () => {
            $emit('retryLogin');
          }
        ">
        {{ $t('login.retry.button') }}
      </button>
      <button
        v-if="loginFailAction === 'reRegister'"
        type="button"
        class="btn btn-lg btn-green"
        @click="retryRegister">
        {{ $t('login.retry.retryFaceButton') }}
      </button>
    </div>

    <i18n tag="div" :path="contractPath" class="contract">
      <template #contract>
        <a :href="contractLink" :target="contractTarget">{{
          contractLinkText
        }}</a>
      </template>
    </i18n>
  </div>
</template>

<script>
  import {
    CUSTOM_COMPANIES,
    otmUserServerUrl,
    USER_V3_STATE_TYPE,
  } from '@/js/common/constants';
  import {changeLocale} from '@/js/common/util';
  export default {
    name: 'RetryLoginGuide',
    props: {
      userId: Number,
      companyId: Number,
      contractLink: String,
      contractLinkText: String,
      contractTarget: String,
      retryLogin: Function,
      loginFailAction: String,
    },
    data() {
      return {
        gteplIds: [CUSTOM_COMPANIES.GTELP_KOREA, CUSTOM_COMPANIES.GTELP_GLOBAL],
      };
    },
    computed: {
      contractPath() {
        return this.gteplIds.includes(this.companyId)
          ? 'login.retry.contractTextGtelp'
          : 'login.retry.contractText';
      },
    },

    mounted() {
      changeLocale(this.companyId);
    },
    methods: {
      retryRegister() {
        location.replace(
          `${otmUserServerUrl}/${USER_V3_STATE_TYPE['PRE_REGISTRATION']}${window.location.search}&retry=true`,
        );
      },
    },
  };
</script>

<style src="@/assets/scss/login_retry.scss" lang="scss" scoped></style>
